// @flow
import Authenticate from "../../modularui/Authenticate";
import { startProgress, finishProgress } from "./ProgressIndicator";
import { resetModularUI } from "../_modularui/ModularUIActions";
import { reloadApplication } from "./Application";

import type { Dispatch, LogoutSuccessAction, ThunkAction } from "../types";

/**
 * Send logout success action
 */
export const logoutSuccess = (): LogoutSuccessAction => ({
  type: "AUTHENTICATION_LOGOUT",
});

/**
 */
export const logout = (): ThunkAction<> => (dispatch: Dispatch) => {
  dispatch(startProgress());

  return new Authenticate()
    .logout()
    .then(() => dispatch(resetModularUI()))
    .then(() => dispatch(reloadApplication()))
    .then(() => {
      dispatch(logoutSuccess());
      return dispatch(finishProgress());
    });
};
